import { pickThemeColor, pickThemeFontSize, pickThemeFontStyles } from '@/theme';
import styled, { css } from 'styled-components';

export const StyledSidebar = styled.aside`
  border-radius: 0.75rem;
  min-width: 15.25rem;
  width: max-content;
  height: fit-content;
  border: 1px solid ${pickThemeColor('LIGHT_PURPLE')};
  background-color: ${pickThemeColor('BG_SECONDARY')};
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const StyledSidebarList = styled.ul`
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  flex-direction: column;

  li {
    width: 100%;
    display: flex;
  }
`;
export const StyledItem = styled.li<{
  $active?: boolean;
}>`
  border-bottom: 1px solid ${pickThemeColor('LIGHT_PURPLE')};
  color: ${pickThemeColor('DARK_PURPLE')};

  &:last-child {
    border-bottom: none;
    border-bottom-left-radius: 0.75rem;
    border-bottom-right-radius: 0.75rem;
    overflow: hidden;
  }

  ${({ $active }) =>
    $active &&
    css`
      background-color: ${pickThemeColor('DARK_PURPLE')};

      button {
        color: ${pickThemeColor('WHITE')};

        &:hover {
          background-color: inherit;
          color: ${pickThemeColor('WHITE')};
        }

        .anticon {
          color: ${pickThemeColor('WHITE')};
        }
      }
    `}
`;

export const StyledLink = styled.button<{
  $active?: boolean;
}>`
  padding: 1rem 1.5rem;
  display: flex;
  gap: 0.75rem;
  ${pickThemeFontStyles('16', '26')};
  text-align: start;
  width: 100%;
  background-color: transparent;
  border: none;
  cursor: pointer;

  .anticon {
    color: ${pickThemeColor('LIGHT_PURPLE')};
    font-size: ${pickThemeFontSize('24')};
  }
`;
